<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Lezioni nel prodotto "{{product?.title.it}}" del pacchetto "{{kit?.title.it}}"</h2>
        <v-btn color="primary" size="small" @click="$router.push(`/kits/${$route.params.kitId}/products/${$route.params.id}/lessons/new`)">Nuovo</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.title" label="Titolo" clearable></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table ref="dataTable" :headers="headers" collection="lessons" :list-collection="`products/${$route.params.id}/lessons`" view-sub-path="" :viewable="false" :editable="false" deletable :query="query" @error="onListError">
          <template v-slot:item.title.it="{ item }">
            <a @click="$router.push(`/kits/${$route.params.kitId}/products/${$route.params.id}/lessons/${item._id}`)" ><strong>{{ item.title.it }}</strong></a>
          </template>

          <template v-slot:item.schedules="{ item }">
            {{ item.schedules.length }} sessioni di esercizio
          </template>

          <template v-slot:item.clone="{ item }">
            <v-btn color="primary" variant="text" icon="mdi-content-copy" v-on:click="requestClone(item._id)"></v-btn>
          </template>
          <template v-slot:item.edit2="{ item }">
            <v-btn color="primary" variant="text" icon="mdi-pencil" v-on:click="$router.push(`/kits/${$route.params.kitId}/products/${$route.params.id}/lessons/${item._id}`)"></v-btn>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type KitDisplay, type Product, type Query} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";
import config from "@/config.ts";
import api from "@/api";


export default defineComponent({
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()
    const route = useRoute()

    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})

    const kit = ref<KitDisplay|undefined>()
    const product = ref<Product|undefined>()

    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      await router.isReady()
      /*
      await Promise.all([
        globals.refresh('categories'),
        globals.refresh('difficulties'),
      ])*/

      const res = await api.get<Product>('products', route.params.id as string)
      product.value = res.data

      const res2 = await api.get<KitDisplay>('kits', route.params.kitId as string)
      kit.value = res2.data
      query.value = utils.getSessionQuery(`products/${route.params.id}/lessons`)
      wh = watch(query.value, ()=>{
        utils.setSessionQuery(`products/${route.params.id}/lessons`, query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      kit,
      product,
      dataTable,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title : 'Titolo', sortable: true, align: 'left', value : 'title.it' },
        { title : 'Sessioni', sortable: true, align: 'left', value : 'schedules' },
        { title : 'Clona', sortable: false, align: 'center', value : 'clone', width : 60 },
        { title : '', sortable: false, align: 'center', value : 'edit2', width : 60 },
      ],
      requestClone( id:string ) {
        messages.requestConfirm('Richiesta conferma',  'Sei sicuro di voler duplicare questo elemento?', false, async ( accepted )=>{
          if(accepted) {
            const res = await api.get('lessons', `${id}/duplicate`)
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError)
            } else {
              await dataTable.value!.loadItems()
              messages.success("Elemento duplicato!")
            }
          }
        });
      },
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
    }
  }
})
</script>
